module.exports = __webpack_public_path__ + "files/71e12a18aa43b9c55503d6cd501c633a.png";